import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { EquipMonitoringComponent } from './equip-monitoring.component';
import { EquipMonitoringRoutingModule } from './equip-monitoring-routing.module';

@NgModule({
  declarations: [EquipMonitoringComponent],
  imports: [
    SharedModule,
    EquipMonitoringRoutingModule,
  ],
})
export class EquipMonitoringModule { }
